import * as React from 'react';

import {translateConnectionObjectToArray} from 'nutshell-core/translate-connection-obj-to-array';

import {TagsEditor} from 'shells/tags-editor/tags-editor';

import {useGetTags} from '../../core/select/hooks/use-get-tags';
import {getTagsFromTagMapEdges, castGraphqlTagsToTagType} from '../../core/tags/helpers';
import {useGetSessionUser} from '../../core/use-get-session-user';
import {useGetContactInfo} from '../../entity-details/peep-details/contact-details/use-get-contact-info';
import {useUpdateContactInfo} from '../../entity-details/peep-details/contact-details/use-update-contact-info';

import {combineFetchedOptionsWithCurrentOptions} from '../select/helpers';

type Props = {
    contactId: string;
};

export function ContactTags(props: Props) {
    const {user} = useGetSessionUser();
    const {contactInfo, isLoading} = useGetContactInfo(props.contactId);
    const contactTags =
        contactInfo && contactInfo.tagMaps ? getTagsFromTagMapEdges(contactInfo.tagMaps.edges) : [];

    const {fetchMore} = useGetTags({
        tagType: 'CONTACT',
    });

    const updateContactInfo = useUpdateContactInfo();
    const handleUpdateContact = (updatedTags: any[]) => {
        const mappedTags = updatedTags.map((tag) => ({tagType: 'CONTACT', name: tag.name}));
        // @ts-expect-error
        updateContactInfo({id: props.contactId, tags: mappedTags});
    };

    if (isLoading) return null;

    return (
        <TagsEditor
            key={props.contactId}
            fetchTags={(searchTerm, currentTags) =>
                fetchMore(searchTerm, 'CONTACT')
                    .then(({data}) =>
                        data
                            ? castGraphqlTagsToTagType(translateConnectionObjectToArray(data.tags))
                            : []
                    )
                    .then((fetchedTags) =>
                        combineFetchedOptionsWithCurrentOptions(fetchedTags, currentTags)
                    )
            }
            appliedTags={contactTags}
            onUpdateTags={handleUpdateContact}
            user={{id: user ? user.id : '', name: user ? user.name : ''}}
        />
    );
}
